<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3 class="card-title" style="margin-top: 7px">
          Müşteri Çarkıfelek Bilgileri
        </h3>
        <button
          class="btn btn-outline-primary btn-sm float-right"
          @click="addManuel()"
          style="margin-left: 5px"
          v-if="
            game == null &&
            auth.CustomerPassionFlower != null &&
            auth.CustomerPassionFlower.isWrite
          "
        >
          <i class="fas fa-plus"></i> Manuel Hak Ekle
        </button>
        <button
          class="btn btn-outline-secondary btn-sm float-right"
          @click="addBlacklist(customer.code)"
          v-if="
            (message ==
              'Müşterinin uygun bir yatırımı bulunmamaktadır! Çarkıfelek hakkı yoktur!' ||
              message == null ||
              message == 'Aktif bir oyun bulunmamakta!') &&
            auth.CustomerPassionFlower != null &&
            auth.CustomerPassionFlower.isWrite
          "
        >
          <i class="fas fa-ban"></i> Kara Listeye Ekle
        </button>
      </div>
      <div class="card-body">
        <div class="overlay-wrapper">
          <div class="overlay" v-if="process">
            <i class="fas fa-3x fa-spinner fa-spin"></i>
          </div>
          <div class="callout callout-danger" v-if="message != null">
            <p class="text-center">
              <span v-html="message"></span>

              <button
                class="btn btn-outline-secondary btn-sm"
                @click="deleteBlacklist(customer.code)"
                style="margin-top: -5px"
                v-if="
                  message !=
                    'Müşterinin uygun bir yatırımı bulunmamaktadır! Çarkıfelek hakkı yoktur!' &&
                  message != 'Aktif bir oyun bulunmamakta!'
                "
              >
                <i class="fas fa-ban"></i> Kara Listeden Çıkar
              </button>
            </p>
          </div>
          <div class="callout callout-success" v-if="game != null">
            <p class="text-center">
              <span v-html="game"></span>

              <button
                class="btn btn-outline-secondary btn-sm"
                @click="deleteManuel(customer.code)"
                style="margin-top: -5px"
                v-if="
                  message !=
                  'Müşteri aktif çarkıfelek oyunundan faydalanabilir...'
                "
              >
                <i class="fas fa-ban"></i> Manuel Hakkı Sil
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h3 class="card-title" style="margin-top: 7px">
          Müşteri Çarkıfelek Logları
        </h3>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 250px">
            <input
              type="text"
              v-model="search"
              class="form-control float-right"
              placeholder="Transaction Ara"
            />

            <div class="input-group-append">
              <button type="submit" class="btn btn-default">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body table-responsive p-0" style="height: 400px">
        <div class="overlay-wrapper">
          <div class="overlay" v-if="overlay">
            <i class="fas fa-3x fa-spinner fa-spin"></i>
          </div>
          <table
            class="table table-head-fixed text-nowrap table-striped projects"
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Tarih</th>
                <th>Durum</th>
                <th>Transaction ID</th>
                <th>İşlem Adı</th>
                <th>Bonus</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in filtered" :key="index">
                <td>{{ ++index }}</td>
                <td>{{ data.date | DateFormat }}</td>
                <td>{{ data.status ? "Kazandı" : "Kaybetti" }}</td>
                <td>{{ data.transaction }}</td>
                <td>{{ data.name }}</td>
                <td>{{ data.bonus }}</td>
              </tr>
              <tr>
                <td v-if="filtered.length == 0" colspan="6" class="text-center">
                  Kayıt Bulunamadı
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- /.card-body -->
    </div>

    <div class="modal fade" id="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Manuel Hak Ekle</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <label>Transaction ID</label>
                <input
                  @blur="$v.manuel.transaction.$touch()"
                  v-model="$v.manuel.transaction.$model"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.manuel.transaction.$error }"
                  placeholder="Transaction ID giriniz"
                />
                <small
                  v-if="
                    !$v.manuel.transaction.required &&
                    $v.manuel.transaction.$error
                  "
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
              </div>

              <div class="form-group">
                <label>Tutar</label>
                <input
                  @blur="$v.manuel.amount.$touch()"
                  v-model="$v.manuel.amount.$model"
                  type="number"
                  class="form-control"
                  :class="{ 'is-invalid': $v.manuel.amount.$error }"
                  placeholder="Tutar giriniz"
                />
                <small
                  v-if="!$v.manuel.amount.required && $v.manuel.amount.$error"
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
              </div>
              <div class="form-group">
                <label>Açıklama</label>
                <textarea
                  v-model="manuel.description"
                  class="form-control"
                  placeholder="Açıklama giriniz"
                ></textarea>
              </div>
            </form>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              İptal
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="save()"
              :disabled="$v.manuel.$invalid"
            >
              Kaydet
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";

export default {
  props: ["customer"],
  data() {
    return {
      datas: [],
      game: null,
      message: null,
      search: "",
      overlay: false,
      process: false,
      manuel: {
        transaction: "",
        amount: "",
        description: "",
      },
      auth: this.$store.getters.getModules,
    };
  },
  validations: {
    manuel: {
      transaction: {
        required,
      },
      amount: {
        required,
      },
    },
  },
  methods: {
    getDatas() {
      this.overlay = true;
      this.$http
        .get("Passionflower/ListRequest/" + this.customer.code)
        .then((response) => {
          this.datas = response.data;
          this.overlay = false;
        });
    },
    getControl() {
      this.process = true;
      this.$http.get("Passionflower/GamesControl/" + this.customer.code).then(
        (response) => {
          this.game = response.data;
          this.message = null;
          this.process = false;
        },
        (error) => {
          this.message = error.data.Message;
          this.game = null;
          this.process = false;
        }
      );
    },
    addManuel() {
      this.manuel = {
        transaction: "",
        amount: "",
        description: "",
      };
      this.$v.$reset();
      $("#modal").modal();
    },
    save() {
      this.process = true;
      this.$http
        .post("Passionflower/GamesManuelAdd/", {
          code: this.customer.code,
          transaction: this.manuel.transaction,
          description: this.manuel.description,
          amount: this.manuel.amount,
        })
        .then(
          (response) => {
            toastr.success("Kayıt Başarlı");
            $("#modal").modal("hide");
            this.getControl();
            this.process = false;
          },
          (error) => {
            toastr.error(error.data.Message);
            this.process = false;
          }
        );
    },
    deleteBlacklist(code, type) {
      this.process = true;
      this.$http
        .get("Passionflower/DeleteBlacklist/" + this.customer.code)
        .then((response) => {
          toastr.success("Kayıt başarıyla silindi.");
          this.process = false;
          this.getControl();
        });
    },
    addBlacklist(code, type) {
      Swal.fire({
        title: "Müşteri kara listeye alınacak! Onaylıyor musunuz?",
        showCancelButton: true,
        confirmButtonText: "Evet! Kara liste",
        cancelButtonText: "İptal",
        icon: "question",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.process = true;
          this.$http
            .get("Passionflower/AddBlacklist/" + this.customer.code)
            .then((response) => {
              toastr.success("Kayıt başarıyla eklendi.");
              this.process = false;
              this.getControl();
            });
        }
      });
    },

    deleteManuel(code, type) {
      Swal.fire({
        title: "Müşterinin manuel hakkı silinecek! Onaylıyor musunuz?",
        showCancelButton: true,
        confirmButtonText: "Evet! Sil",
        cancelButtonText: "İptal",
        icon: "question",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.process = true;
          this.$http
            .get("Passionflower/GamesManuelDelete/" + this.customer.code)
            .then((response) => {
              toastr.success("Kayıt başarıyla silindi.");
              this.process = false;
              this.getControl();
            });
        }
      });
    },
  },
  filters: {
    DateFormat(value) {
      if (!value) return "Belirtilmemiş";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },
  computed: {
    filtered() {
      return this.datas.filter((value) => {
        return value.transaction.match(this.search.toLowerCase());
      });
    },
  },
  created() {
    this.getDatas();
    this.getControl();
  },
  watch: {
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Customer/CustomerPassionflower.vue